import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Svg_Icon from 'root/module/svg_icon';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Video_Bookmark from 'view/feedback_viewer/video_bookmark';

export default View.extend({
    className: 'feedback-video-player',

    inbox_view: false,

    video_player: null,
    is_playing: false,

    duration : 0,
    volume   : 0.2,
    speed    : 1,

    dispatcher: _.extend({}, Backbone.Events),

    views: {
        bookmark: {},
    },

    events: {
        'click .media-control-play'       : 'play',
        'click .media-control-replay'     : 'play',
        'click .media-control-pause'      : 'pause',
        'click .media-control-mute'       : 'mute',
        'input .media-control-volume'     : 'changeVolume',
        'click .media-control-speed'      : 'changeSpeed',
        'click .media-progress'           : 'changeProgress',
        'click .media-control-fullscreen' : 'fullscreen',
        'click .media-bookmark'           : 'addBookmark',
        'click .media-video-overlay'      : 'videoClick',
        'mousedown'                       : 'progressDragStart',
        'mousemove'                       : 'progressDragMove',
        'mouseup'                         : 'progressDragStop',
        'mouseleave'                      : 'progressDragLeave',
        'mouseout .media-bookmark'        : 'bookmarkMouseOut',
        'mousemove .media-bookmark'       : 'bookmarkMouseMove',
        'mouseout .media-progress'        : 'progressMouseOut',
        'mousemove .media-progress'       : 'progressMouseMove'
    },

    dom_handlers: {
        play: function () {
            var is_playing = this.is_playing
                && this.video_player.currentTime > 0
                && !this.video_player.paused
                && !this.video_player.ended
                && this.video_player.readyState > 2;

            if (is_playing) {
                return;
            }

            const play = this.video_player.play();
            if (typeof play === 'undefined') { return; }
            play
                .then(() => {
                    this.is_playing = true;
                    this.$el.find('.media-control-play').hide();
                    this.$el.find('.media-control-replay').hide();
                    this.$el.find('.media-control-pause').show();
                })
                .catch(() => {
                    this.is_playing = false;
                    this.$el.find('.media-control-play').show();
                    this.$el.find('.media-control-pause').hide();
                });
        },
        pause: function () {
            if (!this.is_playing) { return; }
            this.video_player.pause();

            this.$el.find('.media-control-play').show();
            this.$el.find('.media-control-pause').hide();
        },
        videoClick: function(e) {
            if (this.$el.find('.media-video-overlay').hasClass('media-video-overlay-disabled')) {
                return;
            }

            var button = this.$el.find('.media-buttons > button:visible:first');

            button.click();

            this.$el.find('.media-video-overlay').children('div').remove();

            if (button.hasClass('media-control-play') || button.hasClass('media-control-replay')) {
                var indicator = $('<div>').html(Svg_Icon.media_play).appendTo(this.$el.find('.media-video-overlay'));
            } else if (button.hasClass('media-control-pause')) {
                var indicator = $('<div>').html(Svg_Icon.media_pause).appendTo(this.$el.find('.media-video-overlay'));
            }

            setTimeout(function() {
                indicator.remove();
            }, 700);
        },
        mute: function(e) {
            this.video_player.muted = !this.video_player.muted;

            if (this.video_player.muted) {
                this.$el.find('.media-control-mute').html(Svg_Icon.media_volume_muted);
            } else {
                this.$el.find('.media-control-mute').html(Svg_Icon.media_volume);
            }
        },
        changeVolume: function(e) {
            this.volume = $(e.currentTarget).val() / 100;
            this.video_player.volume = this.volume;

            if (this.volume === 0) {
                this.video_player.muted =  true;
                this.$el.find('.media-control-mute').html(Svg_Icon.media_volume_muted);
            } else {
                this.video_player.muted =  false;
                this.$el.find('.media-control-mute').html(Svg_Icon.media_volume);
            }
        },
        changeSpeed: function(e) {
            this.speed = this.speed + 0.5;

            if (this.speed > 3) {
                this.speed = 1;
            }

            this.video_player.playbackRate = this.speed;

            this.$el.find('.media-control-speed span').text(this.speed);
        },
        changeProgress: function(e) {
            var offset_x;

            if ($(e.target).hasClass('media-progress')) {
                offset_x = e.offsetX;
            } else {
                offset_x = e.clientX - this.$el.find('.media-progress').offset().left;
            }

            var current_time = this.getVideoTimeFromOffset(offset_x);
            this.goToTime(current_time);

            if (!this.inbox_view) {
                Router.addQueryString('vt', current_time);
            }
        },
        progressDragStart: function(e) {
            var target = $(e.target);

            if (target.hasClass('media-progress') || target.parents('.media-progress').length) {
                this.is_dragging = true;
            }
        },
        progressDragMove: function(e) {
            if (!this.is_dragging) {
                return;
            }

            this.dom_handlers.changeProgress.call(this, e);
        },
        progressDragStop: function(e) {
            this.is_dragging = false;
        },
        progressDragLeave: function(e) {
            this.is_dragging = false;
        },
        addBookmark: function(e) {
            if (this.isLoading()) {
                return;
            }

            if (this.readonly) {
                return;
            }

            if (!$(e.target).hasClass('media-bookmark')) {
                return;
            }

            var can_comment = Cache.real_user_id || this.model.get('allow_public_comment');
            if (!can_comment) {
                return;
            }

            var current_time = this.getVideoTimeFromOffset(e.offsetX);

            // automatically pause when clicking a bookmark
            this.$el.find('.media-control-pause').click();

            var _add = function() {
                var anon_user = Cache.getGuestUser();

                Cache.app.request({
                    action: 'feedback\\comment/addBookmark',
                    context: this,
                    data: {
                        id         : this.model.id,
                        anon_email : Cache.real_user_id ? '' : anon_user.email,
                        anon_name  : Cache.real_user_id ? '' : anon_user.name,
                        video_time : current_time
                    },
                    success: function(feedback_comment_data) {
                        Cache.feedback_comment.add(feedback_comment_data);
                        UI.success('Bookmark added');
                    }
                });
            }.bind(this);

            if (Cache.real_user_id) {
                _add();
            } else {
                var anon_user = Cache.getGuestUser();

                if (anon_user.email && anon_user.name) {
                    _add();
                } else {
                    Modals.viewerGuest(_add);
                }
            }
        },
        bookmarkMouseOut: function(e) {
            this.$el.find('.bookmark-add-tooltip').hide();
            this.$el.find('.bookmark-add-placeholder').hide();
        },
        bookmarkMouseMove: function(e) {
            if (this.isLoading()) {
                return;
            }

            if (this.readonly) {
                return;
            }

            if (!$(e.target).hasClass('media-bookmark')) {
                return;
            }

            var can_comment = Cache.real_user_id || this.model.get('allow_public_comment');
            if (!can_comment) {
                return;
            }

            var tooltip = this.$el.find('.bookmark-add-tooltip');
            var bookmark_placeholder = this.$el.find('.bookmark-add-placeholder');

            tooltip.show();
            bookmark_placeholder.show();

            var tooltip_left = this.inbox_view ? e.offsetX - tooltip.outerWidth() / 2 : Math.max(e.offsetX - tooltip.outerWidth() / 2, 0);

            tooltip.css('left', tooltip_left);
            bookmark_placeholder.css('left', e.offsetX);
        },
        progressMouseOut: function(e) {
            this.$el.find('.progress-tooltip').hide();
        },
        progressMouseMove: function(e) {
            var offset_x;

            if ($(e.target).hasClass('media-progress')) {
                offset_x = e.offsetX;
            } else {
                offset_x = e.clientX - this.$el.find('.media-progress').offset().left;
            }

            var tooltip = this.$el.find('.progress-tooltip');
            var current_time = this.getVideoTimeFromOffset(offset_x);
            var display_time = this.getDisplayTime(Math.round(current_time));

            tooltip.text(display_time).show();
            tooltip.css('left', Math.max(offset_x - tooltip.outerWidth() / 2, 0));
        },
        fullscreen: function(e) {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.$el.get(0).requestFullscreen();
            }
        }
    },

    player_events: {
        timeUpdate: function(e) {
            var duration     = Math.ceil(this.duration);
            var current_time = Math.ceil(this.video_player.currentTime);

            this.$el.find('.video-time').text(this.getDisplayTime(current_time) + ' / ' + this.getDisplayTime(duration));
            this.$el.find('.play-progress').width(this.video_player.currentTime / this.duration * 100 + '%');
            this.$el.find('.play-progress-circle').css('left', this.video_player.currentTime / this.duration * 100 + '%');

            if (this.video_player.buffered && this.video_player.buffered.length == 1) {
                this.$el.find('.buffered-progress').width(this.video_player.buffered.end(0) / this.duration * 100 + '%');
            }
        },

        ended: function(e) {
            this.$el.find('.play-progress').width('100%');
            this.$el.find('.play-progress-circle').css('left', '100%');

            this.$el.find('.media-control-play').hide();
            this.$el.find('.media-control-replay').show();
            this.$el.find('.media-control-pause').hide();
        }
    },

    event_handlers: {
        newBookmark: function(model) {
            if (model.get('video_time')) {
                var view = this.newBookmarkView(model);

                setTimeout(() => {
                    view.open();
                });
            }
        },

        deleteBookmark: function(model) {
            if (model.get('video_time')) {
                var view = this.views.bookmark[model.id];

                if (view) {
                    view.remove();
                }

                this.$el.find('span.quote[data-id="' + model.id + '"]').remove();
            }
        },

        resolveBookmark: function(model) {
            if (model.get('is_resolved')) {
                this.$el.find('.quote[data-id="' + model.id + '"]').addClass('quote-success');
            } else {
                this.$el.find('.quote[data-id="' + model.id + '"]').removeClass('quote-success');
            }
        },

        onThreadSelect: function(view_cid, model_id) {
            var bookmark_model = Cache.feedback_comment.get(model_id);
            if (bookmark_model) {
                var time = bookmark_model.get('video_time');
                this.goToTime(time);

                if (!this.inbox_view) {
                    Router.addQueryString('vt', time);
                }
            }
        }
    },

    initialize: function(options) {
        this.dispatcher = options.dispatcher || this.dispatcher;
        this.inbox_view = !!options.inbox;
        this.readonly   = !!options.readonly;

        this.listenTo(Cache.feedback_comment, 'add',                this.event_handlers.newBookmark.bind(this));
        this.listenTo(Cache.feedback_comment, 'remove',             this.event_handlers.deleteBookmark.bind(this));
        this.listenTo(Cache.feedback_comment, 'change:is_resolved', this.event_handlers.resolveBookmark.bind(this));

        this.listenTo(this.model, 'change:video_url', this.render);

        var _fullScreenChange = this.fullScreenChange.bind(this);
        var _thread_select    = this.event_handlers.onThreadSelect.bind(this);

        $(document).on('fullscreenchange', _fullScreenChange);
        this.dispatcher.on('Thread:Select', _thread_select);

        this.on('remove', function() {
            $(document).off('fullscreenchange', _fullScreenChange);
            this.dispatcher.off('Thread:Select', _thread_select);
        });
    },

    isLoading: function() {
        return this.$el.find('.media-video-overlay').hasClass('loader');
    },

    newBookmarkView: function(model) {
        this.views.bookmark[model.id] = new View_Feedback_Video_Bookmark({
            model      : model,
            feedback   : this.model,
            duration   : this.duration,
            dispatcher : this.dispatcher
        });

        this.views.bookmark[model.id].render().$el.appendTo(this.$el.find('.media-bookmark'));
        this.views.bookmark[model.id].on('open', this.onBookmarkOpen.bind(this));

        return this.views.bookmark[model.id];
    },

    getVideoTimeFromOffset: function(offset_x) {
        var current_time = offset_x / this.$el.find('.media-progress').width() * this.duration;
        return parseFloat(current_time.toFixed(2));
    },

    getDisplayTime: function(seconds) {
        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10) {
            min = '0' + min;
        }

        if (sec < 10) {
            sec = '0' + sec;
        }

        return (hour ? hour + ':' : '') + min + ':' + sec;
    },

    fullScreenChange: function() {
        if (document.fullscreen) {
            this.$el.find('.media-control-fullscreen').html(Svg_Icon.media_fullscreen_exit);
        } else {
            this.$el.find('.media-control-fullscreen').html(Svg_Icon.media_fullscreen);
        }
    },

    goToTime: function(time) {
        this.$el.find('.play-progress').addClass('clicked');
        this.$el.find('.play-progress-circle').addClass('clicked');
        this.$el.find('.play-progress').width(time / this.duration * 100 + '%');
        this.$el.find('.play-progress-circle').css('left', time / this.duration * 100 + '%');

        // wait for width change to finish
        setTimeout(() => {
            this.$el.find('.play-progress').removeClass('clicked');
            this.$el.find('.play-progress-circle').removeClass('clicked');
            this.video_player.currentTime = time;
        }, 0);
    },

    onBookmarkOpen: function(model) {
        this.goToTime(model.get('video_time'));

        // automatically pause when clicking a bookmark
        this.$el.find('.media-control-pause').click();
    },

    onVideoLoaded: function() {
        this.$el.find('.media-video-overlay').removeClass('loader');
        this.$el.find('.media-buttons').find('button, input').prop('disabled', false);

        // create bookmark views when duration is known
        Cache.feedback_comment.where({feedback_id: this.model.id}).forEach((model) => {
            if (model.get('video_time')) {
                this.newBookmarkView(model);
            }
        });

        this.player_events.timeUpdate.call(this);

        var bookmark_time = Router.getQueryString('vt');
        if (bookmark_time && bookmark_time <= this.duration) {
            this.goToTime(bookmark_time);
        }

        var cache_key = 'feedback_video_xhr_' + this.model.id;
        var is_loaded = Cache.get(cache_key);

        var _renderAnnotation = function() {
            Cache.feedback_annotation.where({feedback_id: this.model.id}).forEach(function(model) {
                $('<span>')
                    .addClass('annotation')
                    .css('left', model.get('video_time') / this.duration * 100 + '%')
                    .appendTo(this.$el.find('.media-progress'));
            }, this);
        }.bind(this);

        if (is_loaded) {
            _renderAnnotation();
        } else {
            Cache.app.request({
                action: 'feedback\\annotation/getData',
                context: this,
                data: {
                    feedback_id: this.model.id
                },
                success: function(response) {
                    Cache.feedback_annotation.add(response);
                    _renderAnnotation();

                    Cache.add(cache_key, true, false);
                }
            });
        }
    },

    pollVideoUrl: function() {
        Cache.app.request({
            action: 'feedback/pollVideoUrl',
            data : {
                id: this.model.id
            },
            context: this,
            success: function(response) {
                if (response.url && response.url !== 'processing') {
                    this.model.set('video_url', response.url);
                } else {
                    setTimeout(function() {
                        this.pollVideoUrl();
                    }.bind(this), 2000);
                }
            }
        });
    },

    pause: function() {
        this.$el.find('.media-control-pause').click();
    },

    onRender: function() {
        if (this.model.get('video_url') === 'processing') {
            this.pollVideoUrl();
            return;
        }

        var video = document.createElement('video');
        var can_play = video.canPlayType('video/webm; codecs="vp8, opus"');

        if (can_play === '') {
            this.$el.find('.media-video-overlay').addClass('media-video-overlay-disabled').html('<p>The&nbsp;<a href="' + this.model.get('video_url') + '" download>video playback</a>&nbsp;is not supported in your browser. Please use the latest version of&nbsp;<i class="fab fa-chrome"></i>&nbsp;<a href="https://www.google.com/chrome/" target="_blank">Chrome</a>&nbsp;or&nbsp;<i class="fab fa-firefox"></i>&nbsp;<a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a>.</p>');
            this.$el.find('.media-video-overlay').removeClass('loader');
            return;
        }

        this.video_player.volume = this.volume;

        var video = $('<video muted>').attr('src', this.model.get('video_url'));

        $(this.video_player).on('timeupdate', this.player_events.timeUpdate.bind(this));
        $(this.video_player).on('ended',      this.player_events.ended.bind(this));

        if (this.model.get('video_length')) {
            // duration is loaded
            this.duration = this.model.get('video_length');
            this.onVideoLoaded();
        } else {
            video.on('durationchange', function(e) {
                const { duration } = video.get(0);
                if (!isNaN(duration) && duration !== Infinity) {
                    // duration is loaded
                    this.duration = duration;

                    // on load
                    this.onVideoLoaded();

                    // save duration
                    Cache.app.request({
                        action: 'feedback/saveVideoDuration',
                        context: this,
                        data: {
                            feedback_id  : this.model.id,
                            video_length : this.duration
                        }
                    });
                }
            }.bind(this));

            video.get(0).currentTime = 99999999;
        }
    },

    render: function() {
        var can_comment = Cache.real_user_id || this.model.get('allow_public_comment');

        var content = '';

        content += '<div class="media-video">' +
                        (this.model.get('video_url') === 'processing' ?
                        '<video></video>' +
                        '<div class="video-processing-status">Processing video. The page will automatically reload once your video is processed.</div>'
                        :
                        '<video preload="auto" src="' + this.model.escape('video_url') + '"></video>') +
                        '<div class="media-video-overlay loader"></div>' + // for dragging progress offsetX
                    '</div>';

        content += '<div class="media-controls">' +
                        '<div class="media-progress">' +
                            '<div class="play-progress"></div>' +
                            '<div class="play-progress-circle"></div>' +
                            '<div class="buffered-progress"></div>' +
                            '<div class="progress-tooltip">00:02</div>' +
                        '</div>' +
                        '<div class="media-bookmark' + (can_comment ? '' : ' media-bookmark-disabled') + '">' +
                            '<div class="bookmark-add-tooltip"><i class="far fa-plus"></i> Add a bookmark</div>' +
                            '<div class="bookmark-add-placeholder"></div>' +
                        '</div>' +
                        '<div class="media-buttons">' +
                            '<button disabled class="media-control-play">' + Svg_Icon.media_play + '</button>' +
                            '<button disabled class="media-control-pause">' + Svg_Icon.media_pause + '</button>' +
                            '<button disabled class="media-control-replay">' + Svg_Icon.media_replay + '</button>' +
                            '<div class="video-time">00:00 / 00:00</div>' +
                            '<button disabled class="media-control-fullscreen">' + Svg_Icon.media_fullscreen + '</button>' +
                            '<input disabled class="media-control-volume dark" type="range" min="0" max="100" step="1" value="' + this.volume * 100 + '">' +
                            '<button disabled class="media-control-mute">' + Svg_Icon.media_volume + '</button>' +
                            '<button disabled class="media-control-speed"><span>1</span><i class="far fa-times"></i></button>' +
                        '</div>' +
                    '</div>';

        this.$el.html(content);

        this.video_player = this.$el.find('video').get(0);

        this.onRender();

        if (this.readonly) {
            this.$el.attr('data-readonly', 1);
        }

        return this;
    }
});
